<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>Сводная таблица</h2>
      <div class="extended-search-block-mobile">
        <div class="search-outline-block">
          <SearchOutlined @click="showMobileFilterModal = true" style="color: rgba(0, 0, 0, 0.45)" />
          <div v-if="currentFiltersLine" class="dot"></div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="action-block upper-block">
        <div class="action-select-wrapper">
          <a-select
              v-model:value="currentGroup"
              :placeholder="'Выберите группу'"
              style="width: 100%;"
              @change="updateFilters"
              :not-found-content="'Нет данных'"
          >
            <a-select-option :key="'all'" :value="'all'">
              Все сотрудники
            </a-select-option>
            <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
              {{ e.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="download-button">
          <a-button class="secondary-button" :loading="excelGenerating" @click="requestForExcelReport">
            <template #icon v-if="!excelGenerating">
              <DownloadOutlined />
            </template>
            Скачать таблицу
          </a-button>
        </div>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="staff"
          :scroll="{ x: 1900 }"
          :pagination="false"
          :loading="tableLoading"
          @change="handleTableChange"
          :table-layout="'fixed'"
          :expandable="expandableConfig"
          :expandIconAsCell="true"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'name'">
            <a class="user-link" @click="router.push(`/staff/${record.id}/edit`)">{{ text }}</a>
          </template>

          <template v-if="column.dataIndex === 'hr_user' && text">
            <a class="user-link" @click="router.push(`/staff/${text.id}/edit`)">{{ text.name }}</a>
          </template>

          <template v-if="column.dataIndex === 'groups'">
            <a-tag v-for="(group) in record.groups" :key="group.id">
              {{ group.name }}
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'is_active'">
            <a-tag color="green" v-if="record.is_active">
              Работает
            </a-tag>
            <a-tag color="red" v-else>
              В архиве
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'results'">
            <div>
              <span class="green-text" @click="handleAction('show-reports', record)">
                Отчеты
              </span>

              <span class="green-text"  @click="handleAction('show-courses', record)">
                История обучения
              </span>
            </div>
          </template>

        </template>

        <template #expandedRowRender="{ record: subRecord }">
          <div class="tabs">
            <a-tabs
                class="simple-green-tabs"
                :animated="false"
                :activeKey="activeSubTableTypeByRow[subRecord.id] ?? getDefaultTabForRow(subRecord)"
                @change="(key) => (activeSubTableTypeByRow[subRecord.id] = key)"
            >
              <a-tab-pane key="assessment" tab="Оценка" />
              <a-tab-pane key="development" tab="Развитие" />
            </a-tabs>
          </div>

          <a-table
              v-if="(activeSubTableTypeByRow[subRecord.id] ?? getDefaultTabForRow(subRecord)) === 'development'"
              class="inner-table"
              :columns="subCourseColumns"
              :data-source="subRecord.courses"
              :pagination="false"
              size="small"
              rowKey="external_id">

            <template #bodyCell="{column, text, record }">
              <template v-if="column.dataIndex === 'name'">
                <div>
                  <span>
                    {{ record.name }}
                  </span>
                </div>
              </template>

              <template v-if="column.dataIndex === 'status'">
                <a-tag color="green" v-if="record.status === 'finished'">
                  Завершен
                </a-tag>
                <a-tag class="yellow-tag" v-else-if="record.status === 'new'">
                  Не начат
                </a-tag>
                <a-tag class="blue-tag" v-else>
                  В процессе
                </a-tag>
              </template>

              <template v-if="column.dataIndex === 'percent_completed'">
                <div class="course-progress">
                  <a-progress :stroke-color="'#21AC0C'" :percent="text ?? 0" :format="percent => `${percent}%`" />
                </div>
              </template>
            </template>

            <template #emptyText>
              <div class="no-data-wrapper">
                <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

                <div class="no-data-text">
                  'Нет данных для отображения.'
                </div>
              </div>
            </template>
          </a-table>

          <a-table
              v-if="(activeSubTableTypeByRow[subRecord.id] ?? getDefaultTabForRow(subRecord)) === 'assessment'"
              class="inner-table"
              :columns="subTestColumns"
              :data-source="subRecord.tests"
              :pagination="false"
              size="small"
              rowKey="code">

            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'report_type'">
                {{ getReportName(text, true) }}
              </template>

              <template v-if="column.dataIndex === 'status'">
                <div v-if="record">
                  <a-tag color="green" v-if="record.status === 'finished'">
                    Завершен
                  </a-tag>
                  <a-tag class="yellow-tag" v-else-if="record.status === 'new'">
                    Не начат
                  </a-tag>
                  <a-tag color="red" v-else-if="record.status === 'expired'">
                    Просрочен
                  </a-tag>
                  <a-tag class="blue-tag" v-else>
                    В процессе
                  </a-tag>
                </div>
                <a-tag v-else>
                  Не выдан
                </a-tag>
              </template>

              <template v-if="column.dataIndex === 'activated_at'">
                <span>
                  {{ record.activated_at_formatted ?? '' }}
                </span>
              </template>

              <template v-if="column.dataIndex === 'completion_time'">
                <div v-if="record.completion_anomaly">
                  <span v-if="!record.completion_anomaly || !record.completion_anomaly">
                  {{ record.completion_time ?? '' }}
                  </span>
                  <a-popover v-else title="Обратите внимание">
                    <template #content>
                      <p>{{ record.anomaly_detail }}</p>
                    </template>
                    <span> {{ record.completion_time ?? '' }} <InfoCircleOutlined style="color: var(--warning-color-1)" /></span>
                  </a-popover>
                </div>
              </template>

              <template v-if="column.dataIndex === 'started_at'">
            <span>
              {{ record.started_at ?? ''}}
            </span>
              </template>

              <template v-if="column.dataIndex === 'finished_at'">
            <span>
              {{ record.finished_at ?? ''}}
            </span>
              </template>

              <template v-if="column.dataIndex === 'expires_at'">
            <span>
              {{ record.expires_at ?? ''}}
            </span>
              </template>

              <template v-if="column.dataIndex === 'results'">
                <div>
              <span class="green-text" @click="handleAction('show-reports', record)">
                Отчеты
              </span>

              <span class="green-text"  @click="handleAction('show-courses', record)">
                История обучения
              </span>
                </div>
              </template>

              <template v-if="column.dataIndex === 'groups'">
                <a-tag v-for="(group) in record.groups" :key="group.id" class="group-tag">
                  {{ group.name }}
                </a-tag>
              </template>
            </template>

            <template #emptyText>
              <div class="no-data-wrapper">
                <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

                <div class="no-data-text">
                  'Нет данных для отображения.'
                </div>
              </div>
            </template>
          </a-table>

        </template>

        <template #emptyText>
          <div class="no-data-wrapper">
            <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

            <div class="no-data-text">
              {{
                currentFiltersLine
                    ? 'Нет данных для отображения. Измените фильтры или запрос.'
                    : 'Нет данных для отображения. Добавьте сотрудников, чтобы начать работу.'
              }}
            </div>

            <a-button
                v-if="currentFiltersLine"
                @click="resetFilters"
            >
              <template #icon>
                <ReloadOutlined />
              </template>
              Сбросить фильтры
            </a-button>
          </div>
        </template>
      </a-table>

      <div class="bottom-container">
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total
                          ="total => `Всего ${total ?? 0} элементов`"
                      :total="totalUsers"
                      @change="handlePageChange"
        />
      </div>
    </div>

    <PassingReportTypes
        :open="currentAction === 'show-reports'"
        v-if="currentAction === 'show-reports'"
        :passings="currentPassing"
        @close="clearCurrentUserAndAction"
        @getAdditionalReports="(data) => {
          showAdditionalReportModal = true;
          originalPassingRecord = data;
        }"
    />

    <DetailsPassings
        :open="currentAction === 'show-courses'"
        v-if="currentAction === 'show-courses'"
        :courses="coursesToShow"
        :email="staff.find(el => el.id === currentActionUser.id).email ?? null"
        @close="clearCurrentUserAndAction"
    />

    <GenerateAdditionalReport
        v-if="showAdditionalReportModal && originalPassingRecord"
        :originalPassing="originalPassingRecord"
        :open="showAdditionalReportModal"
        @closeForm="clearCurrentUserAndAction"
        @generated="refresh"
    />

    <UsersFilterMobileForm
        v-if="showMobileFilterModal"
        :open="showMobileFilterModal"
        @close="showMobileFilterModal = false"
        :groups="groups"
    />
  </div>
</template>

<script>
import {onBeforeMount, onBeforeUnmount, reactive, ref, watch} from "@vue/runtime-core";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed} from "@vue/reactivity";
import {
  SearchOutlined,
  SettingOutlined,
  PlusOutlined,
  ReloadOutlined,
  MenuOutlined,
  DownOutlined,
  ClockCircleOutlined, InfoCircleOutlined, DownloadOutlined
} from '@ant-design/icons-vue'
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import UsersFilterMobileForm from "@/feature/users/UsersFilterMobileForm.vue";
import getReportName from "../../mixins/getReportName";
import AboutTestsModal from "../../feature/testing/modals/AboutTestsModal.vue";
import {message} from "ant-design-vue";
import DetailsPassings from "./DetailsPassings.vue";
import PassingReportTypes from "@/components/Cards/PassingReportTypes.vue";
import GenerateAdditionalReport from "@/feature/testing/forms/GenerateAdditionalReport.vue";

export default {
  name: 'new-groups',
  components: {
    GenerateAdditionalReport, PassingReportTypes,
    DownloadOutlined,
    DetailsPassings,
    InfoCircleOutlined,
    AboutTestsModal,
    UsersFilterMobileForm,
    NewOrderForm,
    ManageAccessForm,
    SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, DownOutlined},
  setup() {

    const store = useStore(),
        router = useRouter();

    const showOrderForm = ref(false);
    const actionToApply = ref();
    const showActionModal = ref();
    const currentAction = ref();
    const modalActionLoading = ref(false);
    const tableLoading = ref(true);
    const groupsLoading = ref(true);
    const statusError = ref({
      groupName: null,
    });

    const activeSubTableTypeByRow = ref({});

    const getDefaultTabForRow = (row) => {
      if (row?.tests?.length) return 'assessment';
      if (row?.courses?.length) return 'development';
      return 'assessment';
    };

    const actionButtonLabels = {
      copy: 'Копировать',
      delete: 'Удалить',
      merge: 'Объединить',
      create: 'Создать'
    }

    const showMobileFilterModal = ref(false);
    const specialStaff = computed(() => store.state.users.specialStaff);
    const blockedStaff = computed(() => store.state.users.showBlocked);
    const hidePagination = ref(false);

    const allGroups = computed(() => store.state.group.groups);
    const groups = ref([]);

    const manageGroupAccessUsers = ref([]);

    const coursesToShow = ref([]);

    const selectedUsers = ref([]);
    const currentActionUser = ref({
      id: null,
      name: '',
      groups: [],
    });

    const showFilterModal = ref(false);
    const entitiesPerPage = ref(10);
    const currentPage = ref(1);
    const filtersPopoverOpen = ref(false);

    const renderClockIcon = ({ record }) => {
      const children = [h('span', record.validUntil)];

      if (record.timeRemaining && record.timeRemaining < 30) {
        children.push(
            h(ClockCircleOutlined, {
              class: 'circle-clock',
              style: {
                color: '#FAAD14',
              },
            }),
        );
      }

      return h(
          'div',
          {
            style: {
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              columnGap: '2px',
              flexDirection: 'row-reverse',
              lineHeight: '1.2',
            },
          },
          children
      );
    }

    const columns = computed(() => [
      {
        title: 'Сотрудник',
        dataIndex: 'name',
        sorter: true,
        width: 250,
      },
      {
        title: 'Должность',
        dataIndex: 'job_title',
        sorter: true,
        width: 150,
      },
      {
        title: 'Почта',
        dataIndex: 'email',
        sorter: true,
        width: 190,
      },
      {
        title: 'Статус',
        dataIndex: 'is_active',
        sorter: false,
        width: 150,
      },
      {
        title: 'Дата добавления',
        dataIndex: 'created_at',
        sorter: false,
        width: 170,
      },
      {
        title: 'Последняя активность',
        dataIndex: 'online_from',
        sorter: true,
        width: 220,
      },
      {
        title: 'Последний вход',
        dataIndex: 'online_from',
        sorter: true,
        width: 170,
      },
      {
        title: 'Результаты',
        dataIndex: 'results',
        sorter: false,
        width: 200,
      },
      {
        title: 'Группы',
        dataIndex: 'groups',
        width: 250,
      },
      {
        title: 'HR-менеджер',
        dataIndex: 'hr_user',
        width: 250,
      },
    ]);

    const subCourseColumns = computed(() => [
      {
        title: 'Развивающее действие',
        dataIndex: 'name',
        width: 170,
        sorter: false,
      },
      {
        title: 'Дата выдачи',
        dataIndex: 'activated_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 100,
      },
      {
        title: 'Тип',
        dataIndex: 'type',
        sorter: false,
        width: 80,
      },
      {
        title: 'Прогресс',
        dataIndex: 'percent_completed',
        sorter: true,
        width: 140,
      },
      {
        title: 'Оценка',
        dataIndex: 'rate',
        sorter: false,
        width: 80,
      },
      {
        title: 'Пройдено',
        dataIndex: 'total_stages',
        sorter: false,
        width: 80,
      },
      {
        title: 'Текущий этап',
        dataIndex: 'current_stage',
        sorter: false,
        width: 180,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 120,
      },
    ]);

    const subTestColumns = computed(() => [
      {
        title: 'Тип тестирования',
        dataIndex: 'report_type',
        width: 170,
        sorter: false,
      },
      {
        title: 'Время начала',
        dataIndex: 'activated_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Длительность',
        dataIndex: 'completion_time',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Распознавание',
        dataIndex: 'branch_1',
        sorter: false,
        width: 100,
      },
      {
        title: 'Использование',
        dataIndex: 'branch_2',
        sorter: false,
        width: 100,
      },
      {
        title: 'Анализ',
        dataIndex: 'branch_3',
        sorter: false,
        width: 100,
      },
      {
        title: 'Управление',
        dataIndex: 'branch_4',
        sorter: false,
        width: 100,
      },
      {
        title: 'Опытный домен',
        dataIndex: 'domain_1',
        sorter: false,
        width: 100,
      },
      {
        title: 'Стратегический домен',
        dataIndex: 'domain_2',
        sorter: false,
        width: 100,
      },
      {
        title: 'Общий ЭИ',
        dataIndex: 'total',
        sorter: false,
        width: 100,
      },
    ]);

    const filters = computed(() => store.state.users.filters);
    const currentFiltersLine = computed(() => store.state.users.filterString);
    const currentGroup = ref('all');

    const totalUsers = computed(() => store.state.users.staffWithProductsTotal);
    const staff = computed(() => store.state.users.staffWithProducts);

    const tableData = reactive({
      tests: []
    });

    const emptySlot = () =>
        h('div', { class: 'no-data-wrapper' }, [
          h('img', { src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);

    const summaryIsLoading = ref(false);

    const onSelectChange = selectedRowKeys => {
      selectedUsers.value = selectedRowKeys;
    };

    // фильтры
    const openFilterModal = () => {
      showFilterModal.value = true;
    }

    const updateFilters = () => {
      filtersPopoverOpen.value = false;
      showMobileFilterModal.value = false;

      currentPage.value = 1;
      fetchUsers();
    }

    const clearCurrentUserAndAction = () => {
      currentAction.value = '';
      actionToApply.value = null;
      showActionModal.value = false;
      currentActionUser.value = {
        id: null,
        name: '',
        groups: [],
      }
      coursesToShow.value = [];
    }

    const resetFilters = () => {
      store.dispatch('users/setUserFilters', {
        filters: {
          name: '',
          job_title: '',
          department: '',
          online_from: '',
          created_at: '',
          email: '',
          telephone: '',
          groups: [],
          without_group_only: false,
        },
        filterString: null,
      });

      currentPage.value = 1;
      fetchUsers();
    }

    //сортировка
    const sortState = ref({
      field: null,
      order: null,
    });

    const handleTableChange = (pagination, filter, sorter) => {
      sortState.value = {
        field: sorter?.field ?? null,
        order: sorter?.order ?? null,
      };

      fetchUsers();
    }

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 110,
          align: 'left',
        },
        {
          title: 'Куплено',
          dataIndex: 'purchased',
          key: 'purchased',
          width: 60,
          align: 'right',
        },
        {
          title: 'Выдано',
          dataIndex: 'issued',
          key: 'issued',
          width: 60,
          align: 'right',
        },
        {
          title: 'Осталось',
          dataIndex: 'remaining',
          key: 'remaining',
          width: 60,
          align: 'right',
        },
        {
          title: 'Завершено',
          dataIndex: 'completed',
          key: 'completed',
          width: 60,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 45,
          align: 'center',
          customRender: renderClockIcon,
        },
      ]
    }

    const fetchUsers = () => {
      tableLoading.value = true;

      store.dispatch("users/getStaffProducts", {
        special_staff: specialStaff.value?.length ? specialStaff.value : null,
        is_blocked: blockedStaff.value ?? null,
        per_page: entitiesPerPage.value,
        page: currentPage.value,
        sort_field: sortState.value.field,
        sort_direction:
            sortState.value.order === 'ascend'
                ? 'asc'
                : sortState.value.order === 'descend'
                    ? 'desc'
                    : null,
        ...filters.value,
        current_group: currentGroup.value === 'all' ?  null : currentGroup.value,
      }).then(() => {

        if (specialStaff.value?.length) {
          hidePagination.value = true;
          store.dispatch('users/clearSpecialStaff');
        } else if (hidePagination.value) {
          hidePagination.value = false;
        }

        store.dispatch('users/clearShowBlocked');

        staff.value = staff.value.map((el) => {
          if (el.tests) {
            el.tests = el.tests.map((test) => {
              if (test.status === 'finished') {
                return {
                  branch_1: test?.balls?.branch_1 ?? null,
                  branch_2: test?.balls?.branch_2 ?? null,
                  branch_3: test?.balls?.branch_3 ?? null,
                  branch_4: test?.balls?.branch_4 ?? null,
                  domain_1: test?.balls?.domain_1 ?? null,
                  domain_2: test?.balls?.domain_2 ?? null,
                  total: test?.balls?.total ?? null,
                  ...test,
                }
              } else {
                return test;
              }
            });
          }

          return el;
        });

        tableLoading.value = false;
      });
    }

    // пагинация
    const retrieveEntitiesPerPage = () => {
      let storageValue = localStorage.getItem('perPage');
      entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
    }

    const setEntitiesPerPage = (num) => {
      localStorage.setItem('perPage', num)
    }

    const handlePageChange = (current, perPage) => {
      if (entitiesPerPage.value !== perPage) {
        entitiesPerPage.value = perPage;
        setEntitiesPerPage(entitiesPerPage.value);
      }

      currentPage.value = current;
      fetchUsers();
    }

    const isMobile = ref(window.innerWidth < 768)

    const onResize = () => {
      isMobile.value = window.innerWidth < 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    const clearCurrentAction = () => {
      currentAction.value = null;
      actionToApply.value = null;

      showActionModal.value = false;
      manageGroupAccessUsers.value = [];
    }

    const fetchAfterSubmit = () => {
      clearCurrentAction();
      fetchUsers();
    }

    onBeforeMount(() => {
      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });

        groupsLoading.value = false;
      });

      summaryIsLoading.value = true;

      store.dispatch('getCompanyActivity').finally(() => {
        summaryIsLoading.value = false;
      })

      retrieveEntitiesPerPage();
      fetchUsers();
    });

    const expandableConfig = computed(() => ({
      rowExpandable: (record) =>
          (Array.isArray(record.courses) && record.courses.length > 0) ||
          (Array.isArray(record.tests) && record.tests.length > 0)
      ,
      showExpandColumn: true,
      columnWidth: 30,
      expandFixed: true,
    }));

    const excelGenerating = ref(false);

    const requestForExcelReport = () => {
      excelGenerating.value = true;

      store
        .dispatch("analytics/getSummaryTableExcel", {
          ...filters.value,
          current_group: currentGroup.value ? currentGroup.value : [],
        })
        .then(({ data }) => {
          window.open(`${process.env.VUE_APP_BACK}/${data}`, "Таблица");
        }).finally(() => {
          excelGenerating.value = false;
        });
    };

    const currentPassing = ref([]);
    const showAdditionalReportModal = ref(false);
    const originalPassingRecord = ref(null);

    const handleAction = (action, userObject = null) => {
      if (userObject) {
        currentActionUser.value.id = userObject.id;
        currentActionUser.value.groups = userObject.groups.map((group) => group.id);
        currentActionUser.value.name = userObject.name;
      } else {
        currentActionUser.value = {
          id: null,
          name: '',
          groups: [],
        };
      }

      currentAction.value = action;

      if (action === 'show-courses') {
        coursesToShow.value = userObject.courses ?? [];
        return;
      }

      if (action === 'show-reports') {
        currentPassing.value = userObject.tests ?? [];
        return;
      }

      showActionModal.value = true;
    }

    const refresh = () => {
      showAdditionalReportModal.value = false;
      originalPassingRecord.value = null;
      currentAction.value = null;
      currentPassing.value = [];

      fetchUsers();
    }

    onBeforeUnmount(() => {
      store.dispatch('group/clearGroupFilters');
    });

    watch(filters, () => {
          updateFilters();
        },
        { deep: true, immediate: true }
    );

    return {
      getReportName,
      router,
      NotFoundIcon,
      currentPage,
      entitiesPerPage,
      columns,
      actionToApply,
      groups,
      onSelectChange,
      currentFiltersLine,
      tableLoading,
      showFilterModal,
      openFilterModal,
      updateFilters,
      filtersPopoverOpen,
      totalUsers,
      handlePageChange,
      showMobileFilterModal,
      handleTableChange,
      isMobile,
      showActionModal,
      modalActionLoading,
      statusError,
      actionButtonLabels,
      clearCurrentAction,
      manageGroupAccessUsers,
      showOrderForm,
      fetchAfterSubmit,
      resetFilters,
      clearCurrentUserAndAction,
      selectedUsers,
      currentAction,
      currentActionUser,
      tableData,
      emptySlot,
      summaryIsLoading,
      staff,
      handleAction,
      getExtendedColumns,
      coursesToShow,
      currentGroup,
      requestForExcelReport,
      excelGenerating,
      currentPassing,
      originalPassingRecord,
      showAdditionalReportModal,
      refresh,
      expandableConfig,
      subCourseColumns,
      subTestColumns,
      activeSubTableTypeByRow,
      getDefaultTabForRow
    }
  }
}
</script>

<style scoped lang="scss">
.view-container {
  padding-top: 0;
  margin-top: 0;
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}

.extended-search-block-mobile {
  display: none;
  margin-right: 10px;

  @media(max-width: 768px) {
    display: block;
  }
}

:deep(.anticon-reload) {
  cursor: pointer;
}

:deep(.anticon-reload:hover) {
  color: var(--main-green) !important;
}

.orders-control {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 16px;
}

.search-outline-block {
  position: relative;
}

.dot {
  position: absolute;
  top: -1px;
  left: 11px;
  height: 5px;
  width: 5px;
  background-color: var(--color-error);
  border-radius: 50%;
}

h2 {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}

.pagination-block {
  margin-left: auto;
  margin-top: 20px;
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  padding-left: 16px;
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.user-link:hover {
  color: var(--hover-color);
}

.order-button {
  display: flex;
  column-gap: 8px;
  margin-top: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 8px;
  }
}

.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 5px;
  padding: 24px;
}

.no-data-wrapper button {
  margin-top: 10px;
}

.no-data-wrapper button:hover {
  border-color: var(--main-green);
  color: var(--main-green);
}

:deep(.ant-btn-text.ant-dropdown-trigger) {
  color: lightgrey;
}

:deep(.ant-btn-text.ant-dropdown-trigger.ant-dropdown-open) {
  color: var(--main-font);
}

:deep(.ant-table-tbody .ant-dropdown-trigger) {
  padding: 4px 5px !important;
}

.action-select-wrapper {
  min-width: 180px;

  @media (max-width: $mobile-breakpoint) {
    width: 100%;

    .ant-select {
      width: 100%;
    }
  }
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.green-text ,
.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.green-text:hover,
.user-link:hover {
  color: var(--hover-green);
}

:deep(.ant-table-row-expand-icon-cell) {
  width: 20px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  text-align: center;
}

.order-button {
  @media(max-width: $mobile-breakpoint) {
    button {
      width: 100%;
    }
  }
}

.download-button {
  margin-left: auto;
}

.bottom-container {
  justify-content: flex-end;
}

.group-tag {
  margin-bottom: 4px;
}

.tabs {
  padding-left: 16px;
}

:deep(.ant-tabs-nav) {
  margin-bottom: 8px;
}
</style>